export const enum MutationNames {
  updateCosts = 'MONTHLY_COSTS_UPDATE_COSTS',
}

export const enum ActionNames {
  getCosts = 'MONTHLY_COSTS_GET_COSTS',
  patchCosts = 'MONTHLY_PATCH_COSTS',
}

export const enum GetterNames {
  costs = 'MONTHLY_COSTS_COSTS',
}
